import "./Card.scss";
const Card = ({ children }) => {
	return <div className='card mb-4'>{children}</div>;
};

export default Card;
